export const CONSULTATION_STAGE = Object.freeze({
  UNAVAILABLE: "UNAVAILABLE",
  SCHEDULED: "SCHEDULED",
  WAITING: "WAITING",
  JOINABLE: "JOINABLE",
  HARD_ENDED: "HARD_ENDED",
});

const HARD_ENDED_REASON = "CONSULTATION_HARD_ENDED";

export const resolvePatientConsultationStage = (consultationContext) => {
  if (!consultationContext || typeof consultationContext !== "object") {
    return CONSULTATION_STAGE.UNAVAILABLE;
  }

  const timing = consultationContext.timing;

  if (
    consultationContext.reason === HARD_ENDED_REASON ||
    timing?.hardEnded === true
  ) {
    return CONSULTATION_STAGE.HARD_ENDED;
  }

  if (consultationContext.consultationAvailable !== true) {
    return CONSULTATION_STAGE.UNAVAILABLE;
  }

  if (!timing || typeof timing !== "object") {
    return CONSULTATION_STAGE.UNAVAILABLE;
  }

  const waitingRoomAccessible = timing.waitingRoomAccessible === true;

  const joinable = timing.joinable === true;

  /*
   * Joining implies that the waiting-room
   * window must already be active.
   */
  if (joinable && !waitingRoomAccessible) {
    return CONSULTATION_STAGE.UNAVAILABLE;
  }

  if (joinable) {
    return CONSULTATION_STAGE.JOINABLE;
  }

  if (waitingRoomAccessible) {
    return CONSULTATION_STAGE.WAITING;
  }

  return CONSULTATION_STAGE.SCHEDULED;
};
